// @flow
import AppHeader from "../../components/AppHeader";
import ScheduleHeaderFilterButton from "./ScheduleHeaderFilterButton";
import React from "react";
import { SuspenseWithPerf } from "reactfire";
import Skeleton from "@material-ui/lab/Skeleton";
import { Box } from "@material-ui/core";
import type { TeamFilterTypes } from "../../common/types";

type Props = {
  teamFilter: TeamFilterTypes,
  setTeamFilter: Function,
};

function ScheduleHeader({ teamFilter, setTeamFilter }: Props) {
  return (
    <AppHeader
      title="Spiele"
      renderButton={() => (
        <SuspenseWithPerf
          traceId="ScheduleHeaderFilterButton"
          fallback={
            <Box style={{ margin: 12 }}>
              <Skeleton variant="circle" width={24} height={24} />
            </Box>
          }
        >
          <ScheduleHeaderFilterButton
            teamFilter={teamFilter}
            setTeamFilter={setTeamFilter}
          />
        </SuspenseWithPerf>
      )}
    />
  );
}

export default ScheduleHeader;
